import request from '@/utils/request'

/**
 *  中标候选人公示
 * */

// 添加
export const winCandidateBulletinAdd = (data) => {
  return request.post('/api/agent/winCandidateBulletin/add', data)
}
// 删除
export const winCandidateBulletinDelete = (data) => {
  return request.post('/api/agent/winCandidateBulletin/delete?winCandidateBulletinCode='+data.winCandidateBulletinCode)
}
// 详情
export const winCandidateBulletinDetail = (winCandidateBulletinCode) => {
  return request.get('/api/agent/winCandidateBulletin/detail?winCandidateBulletinCode='+winCandidateBulletinCode)
}
//初始化
export const winCandidateBulletinInit = (projectCode) => {
  return request.get('/api/agent/winCandidateBulletin/init?projectCode='+projectCode)
}
// 列表
export const winCandidateBulletinList = (data) => {
  return request.get('/api/agent/winCandidateBulletin/list?projectCode='+data.projectCode +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize)
}
//获取标段其他信息
export const winCandidateBulletinOtherInfo = (data) => {
  return request.get('/api/agent/winCandidateBulletin/otherInfo?bidSectionCode='+data.bidSectionCode+"&stage="+data.stage)
}
//生成候选人公式内容
export const winCandidateBulletinCreateContent = (data) => {
  return request.post('/api/agent/winCandidateBulletin/createContent', data)
}
